import { createSlice } from '@reduxjs/toolkit';

import { callerCreator } from '../callerCreator';

const initialState = {
  auto: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVehicleCard: false,
    uploadingLibrettoVeicoloBersani: false,
    uploadingStatoDiFamiglia: false,
    uploadingIdCardFamigliare: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      vehicle_card: 0,
      libretto_veicolo_bersani: 0,
      stato_di_famiglia: 0,
      id_card_famigliare: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    tutela_quotation: null,
    assistenza_quotation: null,
    cristalli_quotation: null,
    infortuni_conducente_quotation: null,
    rivalsa_quotation: null,
    collisione_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    furto_incendio_quotation: null,
    risk_quotations: null,
    thread: null,
  },
  auto_completed: {
    loading: true,
    quote: null,
    error: null,
    insuranceRequest: null,
    quoteStatus: 1,
  },
  autocarro: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVehicleCard: false,
    uploadingLibrettoVeicoloBersani: false,
    uploadingStatoDiFamiglia: false,
    uploadingIdCardFamigliare: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      vehicle_card: 0,
      libretto_veicolo_bersani: 0,
      stato_di_famiglia: 0,
      id_card_famigliare: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    tutela_quotation: null,
    assistenza_quotation: null,
    cristalli_quotation: null,
    infortuni_conducente_quotation: null,
    rivalsa_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  moto: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVehicleCard: false,
    uploadingLibrettoVeicoloBersani: false,
    uploadingStatoDiFamiglia: false,
    uploadingIdCardFamigliare: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      vehicle_card: 0,
      libretto_veicolo_bersani: 0,
      stato_di_famiglia: 0,
      id_card_famigliare: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    tutela_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    thread: null,
  },
  moto_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
  },
  profession: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingModuloDiProposta: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      modulo_di_proposta: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    with_compensation: 0,
    rc_quotation: null,
    tutela_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  profession_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
  },
  infortuni: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    with_compensation: 0,
  },
  travel: {
    loading: true,
    quotation: null,
    insuranceRequest: null,
    quoteStatus: 4,
    backofficeUsers: [],
    rc_quotation: null,
    tutela_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    thread: null,
  },
  travel_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
  },
  commercial: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVehicleCard: false,
    uploadingLibrettoVeicoloBersani: false,
    uploadingStatoDiFamiglia: false,
    uploadingIdCardFamigliare: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      vehicle_card: 0,
      libretto_veicolo_bersani: 0,
      stato_di_famiglia: 0,
      id_card_famigliare: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  commercial_completed: {
    loading: true,
    quote: null,
    error: null,
    insuranceRequest: null,
    quoteStatus: 1,
  },
  tutela_legale: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
      visura_camerale: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  tutela_legale_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
  },
  house: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  house_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  salute: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    // nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  salute_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  ancillari_auto: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  ancillari_auto_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  sanitaria_stranieri: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  sanitaria_stranieri_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  rc_professione_sanita: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  rc_professione_sanita_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  offline_insurances: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  offline_insurances_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  public_employment: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  public_employment_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  malattia: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  malattia_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  infortunio: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  infortunio_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  condominio: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  condominio_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  rc_famiglia: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
    thread: null,
  },
  rc_famiglia_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
  monopattini: {
    loading: true,
    quote: null,
    insuranceRequest: null,
    quoteStatus: 1,
    uploadingIdCard: false,
    uploadingVisuraCamerale: false,
    signMethod: null,
    uploadedFirstDocs: {
      id_card: 0,
    },
    backofficeUsers: [],
    uploadingOptionalDocumentRequestId: null,
    with_compensation: 0,
    rc_quotation: null,
    nonSignableDocs: [],
    requestedOptionalDocumentsNonSignable: [],
    signableDocs: [],
    requestedOptionalDocumentsSignable: [],
    risk_quotations: null,
  },
  monopattini_completed: {
    loading: true,
    quote: null,
    error: null,
    insurance_request: null,
    quoteStatus: 1,
    risk_quotations: null,
  },
};

export const purchasesSlice = createSlice({
  name: 'purchases',
  initialState,
  reducers: {
    autoUpdateState: (state, { payload }) => {
      state.auto = { ...state.auto, ...payload };
    },
    autoResetState: (state) => {
      state.auto = { ...initialState.auto };
    },
    autoCompletedUpdateState: (state, { payload }) => {
      state.auto_completed = { ...state.auto_completed, ...payload };
    },
    autoCompletedResetState: (state) => {
      state.auto_completed = { ...initialState.auto_completed };
    },
    autocarroUpdateState: (state, { payload }) => {
      state.autocarro = { ...state.autocarro, ...payload };
    },
    autocarroResetState: (state) => {
      state.autocarro = { ...initialState.autocarro };
    },
    motoUpdateState: (state, { payload }) => {
      state.moto = { ...state.moto, ...payload };
    },
    motoResetState: (state) => {
      state.moto = { ...initialState.moto };
    },

    professionUpdateState: (state, { payload }) => {
      state.profession = { ...state.profession, ...payload };
    },
    professionResetState: (state) => {
      state.profession = { ...initialState.profession };
    },
    professionCompletedUpdateState: (state, { payload }) => {
      state.profession_completed = { ...state.profession_completed, ...payload };
    },
    professionCompletedResetState: (state) => {
      state.profession_completed = { ...initialState.profession_completed };
    },
    travelCompletedUpdateState: (state, { payload }) => {
      state.travel_completed = { ...state.travel_completed, ...payload };
    },
    travelCompletedResetState: (state) => {
      state.travel_completed = { ...initialState.travel_completed };
    },
    infortuniUpdateState: (state, { payload }) => {
      state.infortuni = { ...state.infortuni, ...payload };
    },
    infortuniResetState: (state) => {
      state.infortuni = { ...initialState.infortuni };
    },
    travelUpdateState: (state, { payload }) => {
      state.travel = { ...state.travel, ...payload };
    },
    travelResetState: (state) => {
      state.travel = { ...initialState.travel };
    },
    commercialUpdateState: (state, { payload }) => {
      state.commercial = { ...state.commercial, ...payload };
    },
    commercialResetState: (state) => {
      state.commercial = { ...initialState.commercial };
    },
    tutelaLegaleUpdateState: (state, { payload }) => {
      state.tutela_legale = { ...state.tutela_legale, ...payload };
    },
    tutelaLegaleResetState: (state) => {
      state.tutela_legale = { ...initialState.tutela_legale };
    },
    tutelaLegaleCompletedUpdateState: (state, { payload }) => {
      state.tutela_legale_completed = { ...state.tutela_legale_completed, ...payload };
    },
    tutelaLegaleCompletedResetState: (state) => {
      state.tutela_legale_completed = { ...initialState.tutela_legale_completed };
    },
    motoCompletedUpdateState: (state, { payload }) => {
      state.moto_completed = { ...state.moto_completed, ...payload };
    },
    motoCompletedResetState: (state) => {
      state.moto_completed = { ...initialState.moto_completed };
    },
    commercialCompletedUpdateState: (state, { payload }) => {
      state.commercial_completed = { ...state.commercial_completed, ...payload };
    },
    commercialCompletedResetState: (state) => {
      state.commercial_completed = { ...initialState.commercial_completed };
    },
    houseUpdateState: (state, { payload }) => {
      state.house = { ...state.house, ...payload };
    },
    houseResetState: (state) => {
      state.house = { ...initialState.house };
    },
    houseCompletedUpdateState: (state, { payload }) => {
      state.house_completed = { ...state.house_completed, ...payload };
    },
    houseCompletedResetState: (state) => {
      state.house_completed = { ...initialState.house_completed };
    },
    saluteUpdateState: (state, { payload }) => {
      state.salute = { ...state.salute, ...payload };
    },
    saluteResetState: (state) => {
      state.salute = { ...initialState.salute };
    },
    saluteCompletedUpdateState: (state, { payload }) => {
      state.salute_completed = { ...state.salute_completed, ...payload };
    },
    saluteCompletedResetState: (state) => {
      state.salute_completed = { ...initialState.salute_completed };
    },
    ancillariAutoUpdateState: (state, { payload }) => {
      state.ancillari_auto = { ...state.ancillari_auto, ...payload };
    },
    ancillariAutoResetState: (state) => {
      state.ancillari_auto = { ...initialState.ancillari_auto };
    },
    ancillariAutoCompletedUpdateState: (state, { payload }) => {
      state.ancillari_auto_completed = { ...state.ancillari_auto_completed, ...payload };
    },
    ancillariAutoCompletedResetState: (state) => {
      state.ancillari_auto_completed = { ...initialState.ancillari_auto_completed };
    },
    sanitariaStranieriUpdateState: (state, { payload }) => {
      state.sanitaria_stranieri = { ...state.sanitaria_stranieri, ...payload };
    },
    sanitariaStranieriResetState: (state) => {
      state.sanitaria_stranieri = { ...initialState.sanitaria_stranieri };
    },
    sanitariaStranieriCompletedUpdateState: (state, { payload }) => {
      state.sanitaria_stranieri_completed = { ...state.sanitaria_stranieri_completed, ...payload };
    },
    sanitariaStranieriCompletedResetState: (state) => {
      state.sanitaria_stranieri_completed = { ...initialState.sanitaria_stranieri_completed };
    },
    professionSanitaUpdateState: (state, { payload }) => {
      state.rc_professione_sanita = { ...state.rc_professione_sanita, ...payload };
    },
    professionSanitaResetState: (state) => {
      state.rc_professione_sanita = { ...initialState.rc_professione_sanita };
    },
    professionSanitaCompletedUpdateState: (state, { payload }) => {
      state.rc_professione_sanita_completed = { ...state.rc_professione_sanita_completed, ...payload };
    },
    professionSanitaCompletedResetState: (state) => {
      state.rc_professione_sanita_completed = { ...initialState.rc_professione_sanita_completed };
    },
    offlineInsurancesUpdateState: (state, { payload }) => {
      state.offline_insurances = { ...state.offline_insurances, ...payload };
    },
    offlineInsurancesResetState: (state) => {
      state.offline_insurances = { ...initialState.offline_insurances };
    },
    offlineQuotationCompletedUpdateState: (state, { payload }) => {
      state.offline_insurances_completed = { ...state.offline_insurances_completed, ...payload };
    },
    offlineQuotationCompletedResetState: (state) => {
      state.offline_insurances_completed = { ...initialState.offline_insurances_completed };
    },
    publicEmploymentUpdateState: (state, { payload }) => {
      state.public_employment = { ...state.public_employment, ...payload };
    },
    publicEmploymentResetState: (state) => {
      state.public_employment = { ...initialState.public_employment };
    },
    publicEmploymentCompletedUpdateState: (state, { payload }) => {
      state.public_employment_completed = { ...state.public_employment_completed, ...payload };
    },
    publicEmploymentCompletedResetState: (state) => {
      state.public_employment_completed = { ...initialState.public_employment_completed };
    },
    malattiaUpdateState: (state, { payload }) => {
      state.malattia = { ...state.malattia, ...payload };
    },
    malattiaResetState: (state) => {
      state.malattia = { ...initialState.malattia };
    },
    malattiaCompletedUpdateState: (state, { payload }) => {
      state.malattia_completed = { ...state.malattia_completed, ...payload };
    },
    malattiaCompletedResetState: (state) => {
      state.malattia_completed = { ...initialState.malattia_completed };
    },
    infortunioUpdateState: (state, { payload }) => {
      state.infortunio = { ...state.infortunio, ...payload };
    },
    infortunioResetState: (state) => {
      state.infortunio = { ...initialState.infortunio };
    },
    infortunioCompletedUpdateState: (state, { payload }) => {
      state.infortunio_completed = { ...state.infortunio_completed, ...payload };
    },
    infortunioCompletedResetState: (state) => {
      state.infortunio_completed = { ...initialState.infortunio_completed };
    },
    condominioUpdateState: (state, { payload }) => {
      state.condominio = { ...state.condominio, ...payload };
    },
    condominioResetState: (state) => {
      state.condominio = { ...initialState.condominio };
    },
    condominioCompletedUpdateState: (state, { payload }) => {
      state.condominio_completed = { ...state.condominio_completed, ...payload };
    },
    condominioCompletedResetState: (state) => {
      state.condominio_completed = { ...initialState.condominio_completed };
    },
    rcFamigliaUpdateState: (state, { payload }) => {
      state.rc_famiglia = { ...state.rc_famiglia, ...payload };
    },
    rcFamigliaResetState: (state) => {
      state.rc_famiglia = { ...initialState.rc_famiglia };
    },
    rcFamigliaCompletedUpdateState: (state, { payload }) => {
      state.rc_famiglia_completed = { ...state.rc_famiglia_completed, ...payload };
    },
    rcFamigliaCompletedResetState: (state) => {
      state.rc_famiglia_completed = { ...initialState.rc_famiglia_completed };
    },
    monopattiniUpdateState: (state, { payload }) => {
      state.monopattini = { ...state.monopattini, ...payload };
    },
    monopattiniResetState: (state) => {
      state.monopattini = { ...initialState.monopattini };
    },
    monopattiniCompletedUpdateState: (state, { payload }) => {
      state.monopattini_completed = { ...state.monopattini_completed, ...payload };
    },
    monopattiniCompletedResetState: (state) => {
      state.monopattini_completed = { ...initialState.monopattini_completed };
    },
  },
});

export default callerCreator(purchasesSlice.actions);
